import { render } from "./GridFuncxFolha.vue?vue&type=template&id=95bffed0"
import script from "./GridFuncxFolha.vue?vue&type=script&lang=js"
export * from "./GridFuncxFolha.vue?vue&type=script&lang=js"

import "./GridFuncxFolha.vue?vue&type=style&index=0&id=95bffed0&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__